import { render, staticRenderFns } from "./createTicket.vue?vue&type=template&id=93b04cc2&scoped=true&"
import script from "./createTicket.vue?vue&type=script&lang=js&"
export * from "./createTicket.vue?vue&type=script&lang=js&"
import style0 from "./createTicket.vue?vue&type=style&index=0&id=93b04cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b04cc2",
  null
  
)

export default component.exports